"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchPiece = MatchPiece;
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_jss_1 = require("react-jss");
const selectors_1 = require("../../hooks/selectors");
const Piece_1 = require("../Piece");
const usePieceCombatState_1 = require("../usePieceCombatState");
const AnimationLayerDiv_1 = require("./AnimationLayerDiv");
const constants_1 = require("./constants");
const useAnimationLayers_1 = require("./useAnimationLayers");
const useStyles = (0, react_jss_1.createUseStyles)({
    pieceContainer: {
        position: "relative",
        zIndex: 50,
        width: "100%",
        height: "100%",
    },
});
function MatchPiece({ piece, viewingPlayerId }) {
    var _a;
    const styles = useStyles();
    const animationEventStore = (0, selectors_1.useGameAnimationEventStore)();
    const combat = (0, usePieceCombatState_1.usePieceCombatState)(piece.id);
    const { layers, isDying, dyingClassName, onLayerAnimationEnd } = (0, useAnimationLayers_1.useAnimationLayers)(piece.id, animationEventStore);
    const color = piece.ownerId === viewingPlayerId ? "friendly" : "enemy";
    const currentHealth = (_a = combat === null || combat === void 0 ? void 0 : combat.currentHealth) !== null && _a !== void 0 ? _a : piece.maxHealth;
    const facing = (combat === null || combat === void 0 ? void 0 : combat.facingAway) ? "back" : "front";
    // Always render a fixed number of wrapper divs so the DOM tree shape
    // never changes - only className/style toggle when animations are active.
    let content = (React.createElement(Piece_1.Piece, { piece: piece, healthbar: { color, current: currentHealth }, facing: facing }));
    for (let i = constants_1.ANIMATION_LAYER_DEPTH - 1; i >= 0; i--) {
        content = (React.createElement(AnimationLayerDiv_1.AnimationLayerDiv, { layer: layers[i], onEnd: onLayerAnimationEnd }, content));
    }
    return (React.createElement("div", { className: (0, classnames_1.default)(styles.pieceContainer, isDying && dyingClassName) }, content));
}
